


























































































































import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import { CustomerAPIKey } from "../../entities/customer";
import { DateTime } from "luxon";

export default Vue.extend({
  components: {},
  data() {
    return {
      search: "",
      dialog: false,
      customerAPIKeyToDelete: {} as CustomerAPIKey,
      headers: [
        { text: "Llave", value: "apikey", sortable: "true" },
        { text: "Fecha de expiración", value: "expireAt", sortable: "true" },
        { text: "Permisos", value: "permissions", sortable: "true" },
        { text: "Acciones", value: "acciones", sortable: "false" },
      ],
    };
  },
  props: {
    customerId: {
      type: Number,
    },
  },
  created() {
    this.$store.dispatch("customers/getAPIKeysByCustomer", this.customerId);
  },
  computed: {
    ...mapGetters("customers", {
      apikeys: "apiKeysTable",
      loading: "apiKeysCustomersLoading",
    }),
  },
  methods: {
    formatDate(date: string): string {
      if (date) {
        const dateTime = DateTime.fromISO(date);
        return dateTime.toFormat("yyyy-MM-dd");
      }
      return "-";
    },
    newAPIKey(): void {
      this.$router.push(`/apikeys/new/`);
    },
    deleteCustomer(customerAPIKey: CustomerAPIKey) {
      this.customerAPIKeyToDelete = customerAPIKey;
      this.dialog = true;
    },
    confirmDeleteAPIKey(): void {
      this.dialog = false;
      this.$store.dispatch("customers/deleteAPIKey", {
        customerId: this.customerAPIKeyToDelete.customerId,
        apiKey: this.customerAPIKeyToDelete.apikey,
      });
    },
  },
});
